/* ============================================================
   SKIO SUBSCRIPTION BLOCK — JS ENHANCEMENTS
   Range Coffee
   
   Product-aware: detects Blend Bundle vs other products
   and shows different badge + benefit text accordingly.
   ============================================================ */

(function() {
  'use strict';

  var CHECK_COLOR = '#1a1a1a';

  // ---- PRODUCT DETECTION ----
  function isBlendBundle() {
    var url = window.location.pathname.toLowerCase();
    // Check URL for blend-bundle handle
    if (url.indexOf('blend-bundle') !== -1) return true;
    // Check page title as fallback
    var title = document.querySelector('h1');
    if (title && title.textContent.trim().toLowerCase().indexOf('blend bundle') !== -1) return true;
    return false;
  }

  // ---- CONFIGURATION PER PRODUCT ----
  function getConfig() {
    if (isBlendBundle()) {
      return {
        badge: 'FREE SHIPPING + FREE GIFT',
        benefits: [
          'Save 15% every month',
          'Modify or cancel anytime',
          'Free Range Coffee Hat',
          'Free Shipping'
        ]
      };
    }
    return {
      badge: 'MOST POPULAR + FREE GIFT',
      benefits: [
        'Save 15% every month',
        'Modify or cancel anytime',
        'Free Range Coffee Hat',
        'Roasted in Laramie, WY'
      ]
    };
  }

  // ---- HELPERS ----
  function checkSVG() {
    return '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M3 8.5L6.5 12L13 4" stroke="' + CHECK_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function injectBadge(container, text) {
    if (container.querySelector('.skio-custom-badge')) return;
    var badge = document.createElement('div');
    badge.className = 'skio-custom-badge';
    badge.textContent = text;
    badge.style.pointerEvents = 'none';
    container.appendChild(badge);
  }

  function injectBenefits(container, benefits) {
    if (container.querySelector('.skio-custom-benefits')) return;

    var content = container.querySelector('.skio-group-content');
    if (content) {
      content.style.maxHeight = 'none';
      content.style.overflow = 'visible';
      content.style.marginLeft = '0';
      content.style.width = '100%';
      content.style.opacity = '1';
    }

    var label = container.querySelector('.skio-group-label');
    if (label) {
      label.style.overflow = 'visible';
    }

    var grid = document.createElement('div');
    grid.className = 'skio-custom-benefits';
    grid.style.pointerEvents = 'none';
    benefits.forEach(function(text) {
      var item = document.createElement('div');
      item.className = 'skio-benefit-item';
      item.innerHTML = checkSVG() + '<span>' + text + '</span>';
      grid.appendChild(item);
    });

    if (content) {
      content.appendChild(grid);
    } else if (label) {
      label.appendChild(grid);
    }
  }

  function fixRadioColors() {
    var selectedContainer = document.querySelector('fieldset.skio-plan-picker .skio-group-container--selected');
    if (!selectedContainer) return;

    var circles = selectedContainer.querySelectorAll('.skio-radio_container svg circle');
    circles.forEach(function(circle) {
      if (circle.getAttribute('fill') && circle.getAttribute('fill') !== 'none') {
        circle.setAttribute('fill', CHECK_COLOR);
      }
      if (circle.getAttribute('stroke') && circle.getAttribute('stroke') !== 'none') {
        circle.setAttribute('stroke', CHECK_COLOR);
      }
    });

    var radioDivs = selectedContainer.querySelectorAll('.skio-radio_container div, .skio-radio_container span');
    radioDivs.forEach(function(el) {
      if (el.style.backgroundColor && el.style.backgroundColor !== 'transparent') {
        el.style.backgroundColor = CHECK_COLOR;
      }
      if (el.style.borderColor) {
        el.style.borderColor = CHECK_COLOR;
      }
    });
  }

  // ---- MAIN ----
  function enhance() {
    var subContainer = document.querySelector('fieldset.skio-plan-picker .skio-group-container:first-of-type');
    if (!subContainer) return false;
    if (subContainer.querySelector('.skio-custom-benefits')) return true;

    var config = getConfig();

    injectBadge(subContainer, config.badge);
    injectBenefits(subContainer, config.benefits);
    fixRadioColors();

    return true;
  }

  function init() {
    var attempts = 0;
    var interval = setInterval(function() {
      if (enhance() || attempts > 30) clearInterval(interval);
      attempts++;
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function() {
    var subContainer = document.querySelector('fieldset.skio-plan-picker .skio-group-container:first-of-type');
    if (subContainer && !subContainer.querySelector('.skio-custom-benefits')) {
      setTimeout(enhance, 150);
    }
    setTimeout(fixRadioColors, 100);
  });

  var formTarget = document.querySelector('form[action*="/cart"]') || document.body;
  observer.observe(formTarget, { childList: true, subtree: true, attributes: true });
})();